import apiClient from "./billingServiceClient";

export const fetchPlanDetails = async () => {
  const response = await apiClient.get("/plans");
  return response.data;
};

export default {
  fetchPlanDetails,
};
